import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import type { MortgageResponseItem } from "@/component/Mortgage/Calculator/types";
import { ButtonLegacy, List } from "@/shared/ui";
import { formatText } from "@/shared/ui/format";

export type StepFields = {};

interface Props extends AbstractStepProps {
	loanAmount: number;
	maturity: number;
	result: MortgageResponseItem;
}

export class Result extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { loanAmount, maturity, result } = this.props;

		if (!result) {
			return null;
		}

		const { apr, installmentStart } = result;

		return (
			<>
				<Card.Header className="bg-secondary-gradient text-white text-center py-3">
					<mark className="bg-white text-secondary display-6 font-weight-bold">
						{formatText(Math.floor(loanAmount / 1_000_000), "ft").replace("Ft", "millió Ft")} hitel{" "}
						{maturity} évre
					</mark>
					<div className="display-2 font-weight-bold mb-0 mt-3">{formatText(installmentStart, "ft")}</div>
					<div className="font-weight-bold mb-3">Havi törlestőtől</div>
					<div className="display-6 font-weight-bold mb-3">{formatText(apr, "%")} THM-től</div>
					<div className="small">
						Beállításaid alapján ezekkel a<br /> kondíciókkal érhető el lakáshitel
					</div>
				</Card.Header>
				<Card.Body className="py-2">
					<div className="h4 text-center mb-3">
						A részletes eredményeidet
						<br />
						email-ben küldjük el
					</div>
					<List itemStyle="tick" variant="secondary">
						<List.Item>
							Milyen <strong>kamattal</strong>, teljes <strong>visszafizetéssel</strong> és{" "}
							<strong>induló költséggel</strong> számolhatsz?
						</List.Item>
						<List.Item>
							<strong>Mennyi idő</strong> alatt és <strong>milyen feltételekkel</strong> kaphatod meg a
							fenti hitelt?
						</List.Item>
						<List.Item>
							<strong>Szakértőink segítenek</strong> bármilyen felmerülő kérdésedben
						</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy variant="secondary" type="submit" size="lg">
						Kérem az eredményeimet
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
